export const SET_BANNERS_DATA = 'SET_BANNERS_DATA';

export const setBannersData = (payload) => {
  return { type: SET_BANNERS_DATA, payload };
};
